import React from 'react';
import { useDropzone } from 'react-dropzone';

const MAX_FILE_SIZE_BYTES = 25 * 1024 * 1024;

const DragDropComponent = ({ setFile, onReject, maxSize = MAX_FILE_SIZE_BYTES }) => {
    const { getRootProps, getInputProps, acceptedFiles, isDragActive, isDragAccept, isDragReject } = useDropzone({
        accept: {
            'application/pdf': []
        },
        maxSize,
        onDrop: (acceptedFiles, fileRejections) => {
            if (fileRejections.length > 0) {
                onReject?.(fileRejections);
                return;
            }
            setFile(acceptedFiles)
        }
    });
    const files = acceptedFiles.map(file => (
        <li key={file.path}>{file.path} - {file.size} bytes</li>
    ));

    return (
        <div {...getRootProps()}>
            <input {...getInputProps()} />
            <ul>{files}</ul>
            <div className="add-pdf-file">
                <span>
                    Drag file here, or
                </span>
                <span>
                    <button type="file" className="file-btn ms-2">
                        <i className="fa-regular fa-file me-2"></i>Choose file
                    </button>
                </span>
            </div>
        </div>
    );
};

export default DragDropComponent;
